module.exports = __webpack_public_path__ + "img/parallaxScrolling.1fbd1155.gif";